module.exports = __webpack_public_path__ + "static/media/2 5 tattoo arm sleeve antelope safari savanna sunset realism.1280x1706.21035d34.webp";